/**
 * Created by r4zi4l on 17.09.2021
 */

const OrdersWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this.orders = new Orders(options);

        const maker = this.orders.getCurrentMaker();

        this._super({
            name: "OrdersWindow",
            title: Messages.get("OrdersWindow.title"),
            noPadding: true,
            closeButton: true,
            content: this.createContent(maker),
            foreground: bundles.windows.frames.window_foreground_png
        });

        this.icons.forEach((icon) => {
            icon.updateSelection(maker);
        });

        this.orders.on("orderClaimed", this.onOrderClaimed.bind(this), this);
        this.orders.on("ingredientsConsumed", this.onIngredientsConsumed.bind(this), this);
    },

    createContent: function (maker) {
        const styles = cleverapps.styles.OrdersWindow;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles);

        const gridScroll = this.createGridScroll(maker);
        gridScroll.setAlignment(styles.grid);
        content.addChild(gridScroll);

        const details = this.details = new OrderDetails(this.orders);
        details.setAnchorPoint(0.5, 0.5);
        details.setAlignment(styles.details);
        content.addChild(details);

        return content;
    },

    createGridScroll: function (maker) {
        const styles = cleverapps.styles.OrdersWindow.grid;
        const grid = this.createGrid();

        const scroll = this.scroll = new cleverapps.UI.ScrollView(grid, {
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL
        });
        scroll.setContentSize(styles.scroll.width, styles.scroll.height);

        for (let i = 0; i < this.icons.length; ++i) {
            if (this.icons[i].maker === maker) {
                scroll.runAction(new cc.ScrollAction(this.icons[i], { silent: true }));
                break;
            }
        }

        const background = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.orders_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(styles);

        background.addChild(scroll);
        scroll.setAlignment(background.width / 2, background.height / 2);

        const foreground = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.orders_foreground, cleverapps.UI.Scale9Rect.TwoPixelXY);
        foreground.setContentSize2(background.getContentSize());
        foreground.setAlignment(background.width / 2, background.height / 2);
        background.addChild(foreground);

        return background;
    },

    createGrid: function () {
        const styles = cleverapps.styles.OrdersWindow.grid;

        const icons = this.icons = Map2d.currentMap.customers.listCustomersWithRecipe().map(function (customer) {
            return new OrderIcon(customer, this.orders);
        }, this);

        if (icons.length === 0) {
            const text = cleverapps.UI.generateOnlyText(Messages.get("OrdersWindow.placeholder"), cleverapps.styles.FONTS.LIGHT_TEXT);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.setDimensions(styles.width * 0.9, 0);
            return text;
        }

        const grid = new cleverapps.GridLayout(icons, {
            columns: 3,
            margin: styles.margin,
            padding: styles.padding
        });

        icons.forEach((icon) => {
            icon.unitsLayer.replaceParentSamePlace(grid);
        });

        return grid;
    },

    onOrderClaimed: function (maker) {
        this.readyMaker = maker.unit;
        this.close();
    },

    onIngredientsConsumed: function (maker) {
        const ingredients = this.details.ingredients.listIcons();

        const flyToTarget = function (target) {
            let position;
            this.runAction(new cc.Sequence(
                new cc.CallFunc(() => {
                    position = this.convertToNodeSpace(target.parent.convertToWorldSpace(target.getPosition()));

                    ingredients.forEach(function (icon) {
                        const flyingIcon = new IngredientOrderIcon(icon.ingredient);
                        flyingIcon.setAlignment(this.convertToNodeSpace(icon.parent.convertToWorldSpace(icon.getPosition())));
                        flyingIcon.setLocalZOrder(10);
                        this.addChild(flyingIcon);

                        flyingIcon.runAction(new cc.Sequence(
                            new cc.JumpTo(0.8, position.x, position.y, cleverapps.styles.OrderIcon.fly.height, 1),
                            new cc.RemoveSelf()
                        ));
                    }, this);
                }),
                new cc.DelayTime(0.8),
                cleverapps.effects.fireAction("merge.unit.destroy"),
                new cc.CallFunc(() => {
                    const animation = new cleverapps.Spine(bundles.orderswindow.jsons.ow_rewards_highlight_json);
                    animation.setScale(1.7);
                    animation.setAnchorPoint(0.5, 0.5);
                    animation.setAlignment(position.x, position.y);
                    animation.setAnimation(0, "animation", false);
                    animation.setCompleteListenerRemove();
                    this.addChild(animation);
                }),
                new cc.DelayTime(0.1),
                new cc.CallFunc(() => {
                    target.setFreeze(false);
                    target.updateState(target.maker);
                })
            ));
        }.bind(this);

        let target;
        for (let i = 0; i < this.icons.length; ++i) {
            if (this.icons[i].maker === maker) {
                target = this.icons[i];
                target.setFreeze(true);

                this.scroll.runAction(new cc.Sequence(
                    new cc.ScrollAction(target, {
                        duration: 0.5,
                        visibleBox: {
                            top: 0.97,
                            bottom: 0.97
                        }
                    }),
                    new cc.CallFunc(flyToTarget.bind(this, target))
                ));

                break;
            }
        }
    },

    beforeCloseAnimation: function (callback) {
        if (!this.readyMaker) {
            callback();
            return;
        }

        const windowComponent = ComponentMap.get(this, WindowComponent);
        windowComponent.hideWindow();

        Map2d.currentMap.focusOnUnit(this.readyMaker, {
            allowScrollWithFocus: true,
            delay: 1,
            action: function () {
                this.readyMaker.handleClick();
            }.bind(this),
            callback
        });
    },

    listBundles: function () {
        return ["main", "orders_portraits"];
    }
});

cleverapps.styles.OrdersWindow = {
    width: 1590,
    height: 960,

    grid: {
        x: { align: "left", dx: 65 },
        y: { align: "center", dy: -10 },
        width: 800,
        height: 835,

        scroll: {
            width: 800,
            height: 810
        },

        margin: {
            x: 20,
            y: 20
        },

        padding: {
            x: 30,
            y: 30
        },

        text: {
            x: { align: "center" },
            y: { align: "center" }
        }
    },

    details: {
        x: { align: "right", dx: -60 },
        y: { align: "center", dy: 0 }
    }
};
